<template>
  <div class="layer">
    <div class="layer__content">
      <div class="layer__header">
        <h2 class="layer__title">{{ getTitle }}</h2>
        <iconBase :gradientOn="true">
          <component :is="dynamicComponent"></component>
        </iconBase>
      </div>

      <div class="layer__body" v-bar>
        <div>
          <div class="layer__body__content" v-html="input"></div>
        </div>
      </div>
    </div>

    <div class="sidebar">
      <router-link class="layer__close" :to="{ name: 'homepage' }">
        <svg xmlns="http://www.w3.org/2000/svg" width="30.38" height="30.375">
          <path
            d="M30.39 28.269l-2.12 2.121-13.08-13.082L2.11 30.387l-2.12-2.121 13.08-13.079L-.01 2.106 2.11-.015l13.08 13.081L28.27-.013l2.12 2.121-13.08 13.079z"
            fill="#fff"
            fill-rule="evenodd"
          />
        </svg>
      </router-link>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import iconBase from "./icons/iconBase";
import iconFamily from "./icons/iconFamily";
import iconJob from "./icons/iconJob";
import iconEducation from "./icons/iconEducation";
import iconHealth from "./icons/iconHealth";
import iconSecurity from "./icons/iconSecurity";
import iconDiplomacy from "./icons/iconDiplomacy";

export default {
  components: {
    iconBase,
    iconFamily,
    iconJob,
    iconEducation,
    iconHealth,
    iconSecurity,
    iconDiplomacy,
  },
  props: {
    isOpen: {
      type: Boolean
    },
    type: {
      type: String
    },
    icon: {
      type: String
    },
    boxes: {
      type: Array
    }
  },

  data() {
    return {
      fileName: "",
      input: "",
      slug: "",
      title: ""
    };
  },
  created() {
    this.slug = this.$route.params.slug;
    this.fileName = this.$route.params.slug;
    this.loadFile();
  },
  methods: {
    close() {
      this.$emit("close");
    },
    loadFile() {
      axios({
        method: "get",
        url: "static/" + this.fileName + ".html?t=" + Date.now()
      })
        .then(result => {
          this.input = result.data;
        })
        .catch(error => {
          console.error("error getting file" + error);
        });
    }
  },
  computed: {
    getImage() {
      return "assets/images/png/" + this.icon;
    },
    getTitle() {
      const boxes = this.boxes.filter(elem => elem.title === this.slug);
      return boxes[0].name;
    },
    dynamicComponent() {
      const boxes = this.boxes.filter(elem => elem.title === this.slug);
      return boxes[0].icon;
    }
  },
  mounted() {
    document.body.classList.add("-is-covered");
  },
  destroyed() {
    document.body.classList.remove("-is-covered");
  }
};
</script>

<style lang="scss">
.slide-enter-active,
.slide-leave-active {
  transition: transform 600ms ease;
}

.slide-enter,
.slide-leave-to {
  transform: translate3d(100%, 0, 0);
}

.layer {
  position: fixed;
  height: 100vh;
  width: 100%;
  background: #fff;
  top: 0;
  right: 0;
  z-index: 60;
}

.sidebar {
  width: 70px;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  background-color: #f7902d;
  z-index: 10;
  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(
      0deg,
      rgba(219, 107, 0, 1) 0%,
      rgba(219, 107, 0, 0) 60%
    );
  }
}

.layer__close {
  margin: 20px 0 0 10px;
  display: inline-block;
  position: relative;
  z-index: 100;
}

.layer__content {
  width: calc(100% - 70px);
  height: 100%;

  &::after {
    // content: "";
    position: absolute;
    width: 100%;
    height: 171px;
    bottom: 0;
    left: 0;
    background-image: linear-gradient(
      0deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 0.09) 91%,
      rgba(255, 255, 255, 0) 100%
    );
  }
}

.layer__title {
  color: #063e89;
  font-size: 40px;
  font-family: "Anton", sans-serif;
  font-weight: normal;
  text-transform: uppercase;
  margin: 0;
}

.layer__header {
  display: flex;
  padding: 0 20px;
  justify-content: space-between;
  align-items: center;
  height: 160px;
  border-bottom: 1px solid #f7902d;
  box-shadow: 0px 7px 0px 0px rgba(255, 229, 205, 1);
  z-index: 1;
}

.layer__body {
  height: calc(100% - 160px);
  margin-top: 7px;
}

.layer__body__content {
  padding: 0 20px;
}

.layer {
  svg {
    height: 105px;
  }
}

@media screen and (min-width: 480px) {
}

@media screen and (min-width: 970px) {
  .layer {
    width: 80vw;
  }

  .layer__header {
    padding: 0 50px;
  }

  .sidebar {
    width: 150px;
  }

  .layer__close {
    margin: 30px 0 0 30px;
  }

  .layer__body__content {
    padding: 0 50px;
  }

  .layer__content {
    width: calc(100% - 150px);
  }

  .layer__title {
    font-size: 46px;
  }
}

@media screen and (min-width: 1170px) {
  .layer {
    width: 80vw;
  }

  .layer__title {
    font-size: 54px;
  }
}

@media screen and (min-width: 1452px) {
  .layer {
    width: 60vw;
  }

  .layer__title {
    font-size: 58px;
  }
}
</style>
